<template>
  <div>
    <language-tap-bar
      data-test="localizationControllerTapBar"
      :language-code="language.code"
      :inverted-color="invertedColor"
      @click="handleShown"
    />

    <languages-list-modal
      v-model="isShownLanguagesList"
      data-test="localizationControllerModal"
      :languages="formattedLanguages"
      @change-localization="handleChange"
    />
  </div>
</template>

<script>
import { getLanguages } from 'services/localization';

import LanguageTapBar from 'organisms/localization/LanguageTapBar';
import LanguagesListModal from 'organisms/localization/LanguagesListModal';

import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'LocalizationController',
  components: {
    LanguageTapBar,
    LanguagesListModal,
  },
  props: {
    language: {
      type: Object,
      required: true,
    },
    invertedColor: {
      type: Boolean,
      default: () => false,
    },
  },
  created() {
    this.loadLanguages();
  },
  data() {
    return {
      languagesList: [],
      isShownLanguagesList: false,
    };
  },
  computed: {
    formattedLanguages() {
      return this.languagesList.map(language => {
        return {
          ...language,
          active: language.code === this.language.code,
          description: this.$t(language.description),
        };
      });
    },
  },
  methods: {
    async loadLanguages() {
      try {
        this.languagesList = await getLanguages({ type: 'cabinet' });
      } catch (error) {
        console.error(error);
      }
    },
    handleShown() {
      this.isShownLanguagesList = true;
    },
    handleChange(language) {
      EVENT_BUS.$emit('change.localization', {
        code: language.code,
        description: language.description,
        id: language.id,
        title: language.title,
      });
    },
  },
};
</script>
